import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

type Instruction = server.dto.ListHubSpotDealInstruction & { page: number, perPage: number };

const HubSpotDealList = (props: PickerListProps<server.dto.HubSpotDeal>) => {
  const [instruction, setInstruction] = React.useState<Instruction>({
    keyword: "",
    includeClosedLost: false,
    // Dummy properties to satisfy the type
    page: 1,
    perPage: 10
  });

  return <>
    <PickerList<server.dto.HubSpotDeal, number | string, Instruction>
      instruction={instruction}
      onInstructionChange={setInstruction}
      queryKey="hubspotList"
      api={window.CoreApi.HubSpot.SearchDeals}
      onClick={props.onItemSelected}
      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      getId={c => c.id}
      renderListItem={hsDeal => <div className="flex gap">
        <div className="grow1">
          <div>{hsDeal.dealName}</div>
          <div className="text-sublabel">{hsDeal.stageLabel}</div>
        </div>
      </div>
      }
      otherFilters={<Checkbox label={"Include closed lost deals"} checked={instruction.includeClosedLost} onChange={(_, checked) => setInstruction(prev => ({ ...prev, includeClosedLost: checked }))} />}

    />
  </>;
};

export default HubSpotDealList;